var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("h3", [_vm._v(" Mes commandes ")]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        _vm._l(_vm.parcels, function(parcel, indexParcel) {
          return _c("div", { key: indexParcel }, [
            _c("div", { staticClass: "d-flex flex-row w-100 mb-2" }, [
              _c("h4", { staticClass: "flex-grow-1 mb-0" }, [
                _vm._v(
                  " Commande du " +
                    _vm._s(
                      _vm
                        .$moment(parcel.createdAt)
                        .format("DD/MM/YYYY [à] HH:mm")
                    ) +
                    " "
                )
              ])
            ]),
            _c("div", { staticClass: "alert alert-light" }, [
              _c("h6", { staticClass: "fw-bold" }, [_vm._v("Statut")]),
              _vm._v(
                " Le " +
                  _vm._s(
                    _vm.$moment(parcel.pa_date).format("DD/MM/YYYY [à] HH:mm")
                  ) +
                  " : " +
                  _vm._s(_vm.getOrderStatus(parcel.pa_state)) +
                  " "
              ),
              parcel.pa_state === "SENT"
                ? _c("div", [
                    _vm._v(
                      " Mode de livraison : " +
                        _vm._s(_vm.getDeliveryCompany(parcel.pa_company))
                    ),
                    _c("br"),
                    _vm._v(
                      " N° de suivi : " + _vm._s(parcel.pa_trackingcode) + " "
                    )
                  ])
                : _vm._e(),
              _c("h6", { staticClass: "fw-bold mt-4" }, [
                _vm._v("Adresse de livraison")
              ]),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: parcel.pa_shipping_civility,
                      expression: "parcel.pa_shipping_civility"
                    }
                  ]
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.getCivility(parcel.pa_shipping_civility)) +
                      "  "
                  )
                ]
              ),
              _vm._v(
                " " +
                  _vm._s(parcel.pa_shipping_firstname) +
                  " " +
                  _vm._s(parcel.pa_shipping_name)
              ),
              _c("br"),
              _c("div", { staticClass: "mt-2" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: parcel.pa_shipping_society_name,
                        expression: "parcel.pa_shipping_society_name"
                      }
                    ]
                  },
                  [_vm._v(" " + _vm._s(parcel.pa_shipping_society_name) + " ")]
                ),
                _vm._v(" " + _vm._s(parcel.pa_shipping_address1) + " "),
                _c("br"),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: parcel.pa_shipping_address2,
                        expression: "parcel.pa_shipping_address2"
                      }
                    ]
                  },
                  [
                    _vm._v(" " + _vm._s(parcel.pa_shipping_address2) + " "),
                    _c("br")
                  ]
                ),
                _vm._v(
                  " " +
                    _vm._s(parcel.pa_shipping_zip) +
                    " " +
                    _vm._s(parcel.pa_shipping_city) +
                    " "
                ),
                _c("br"),
                _vm._v(
                  " " + _vm._s(_vm.getCountry(parcel.pa_shipping_country)) + " "
                )
              ]),
              _c("div", { staticClass: "mt-2" }, [
                _c("label", [_vm._v("téléphone : ")]),
                _vm._v(" " + _vm._s(parcel.pa_shipping_tel) + " ")
              ]),
              _c("h6", { staticClass: "fw-bold mt-4" }, [
                _vm._v("Commentaire")
              ]),
              _vm._v(" " + _vm._s(parcel.pa_comment) + " ")
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }